import React, {useEffect, useRef, useState} from 'react';
import Tippy from '@tippyjs/react';
import * as Icon from 'react-feather';
import config from '../querybuilder/config.json';
import './MapYearSelect.scss';
import Select from 'react-select';

const mapYears = [
  {label: '1951', value: '1951'},
  {label: '1952', value: '1952'},
  {label: '1953', value: '1953'},
  {label: '1954', value: '1954'},
  {label: '1955', value: '1955'},
  {label: '1956', value: '1956'},
  {label: '1957', value: '1957'},
  {label: '1958', value: '1958'},
  {label: '1959', value: '1959'},
  {label: '1960', value: '1960'},
  {label: '1961', value: '1961'},
  {label: '1962', value: '1962'},
  {label: '1963', value: '1963'},
  {label: '1964', value: '1964'},
  {label: '1965', value: '1965'},
  {label: '1966', value: '1966'},
  {label: '1967', value: '1967'},
  {label: '1968', value: '1968'},
  {label: '1969', value: '1969'},
  {label: '1970', value: '1970'},
  {label: '1971', value: '1971'},
  {label: '1972', value: '1972'},
  {label: '1973', value: '1973'},
  {label: '1974', value: '1974'},
  {label: '1975', value: '1975'},
  {label: '1976', value: '1976'},
  {label: '1977', value: '1977'},
  {label: '1978', value: '1978'},
  {label: '1979', value: '1979'},
  {label: '1980', value: '1980'},
  {label: '1981', value: '1981'},
  {label: '1982', value: '1982'},
  {label: '1983', value: '1983'},
  {label: '1984', value: '1984'},
  {label: '1985', value: '1985'},
  {label: '1986', value: '1986'},
  {label: '1987', value: '1987'},
  {label: '1988', value: '1988'},
  {label: '1989', value: '1989'},
  {label: '1990', value: '1990'},
  {label: '1991', value: '1991'},
  {label: '1992', value: '1992'},
  {label: '1993', value: '1993'},
  {label: '1994', value: '1994'},
  {label: '1995', value: '1995'},
  {label: '1996', value: '1996'},
  {label: '1997', value: '1997'},
  {label: '1998', value: '1998'},
  {label: '1999', value: '1999'},
  {label: '2000', value: '2000'},
  {label: '2001', value: '2001'},
  {label: '2002', value: '2002'},
  {label: '2003', value: '2003'},
  {label: '2004', value: '2004'},
  {label: '2005', value: '2005'},
  {label: '2006', value: '2006'},
  {label: '2007', value: '2007'},
  {label: '2008', value: '2008'},
  {label: '2009', value: '2009'},
  {label: '2010', value: '2010'},
  {label: '2011', value: '2011'},
  {label: '2012', value: '2012'},
  {label: '2013', value: '2013'},
  {label: '2014', value: '2014'},
  {label: '2015', value: '2015'},
  {label: '2016', value: '2016'},
  {label: '2017', value: '2017'},
  {label: '2018', value: '2018'},
  {label: '2019', value: '2019'},

];

const lastMapYearIndex = mapYears.length - 1;
export const defaultMapYears = [
  mapYears[lastMapYearIndex - 11],
  mapYears[lastMapYearIndex - 10],
  mapYears[lastMapYearIndex - 9],
  mapYears[lastMapYearIndex - 8],
  mapYears[lastMapYearIndex - 7],
  mapYears[lastMapYearIndex - 6],
  mapYears[lastMapYearIndex - 5],
  mapYears[lastMapYearIndex - 4],
  mapYears[lastMapYearIndex - 3],
  mapYears[lastMapYearIndex - 2],
  mapYears[lastMapYearIndex - 1],
  mapYears[lastMapYearIndex],
];

const isSiteInDarkMod = () => {
  const el = document.querySelector('html[data-theme]');

  if (el) {
    const { theme } = el.dataset;

    if (theme) {
      return theme === 'dark';
    }
  }
  return false;
}

const MapYearSelect = ({mapYearCallback}) => {
  const mapYearOptions = useRef(null);
  const [selectedOption, setSelectedOption] = useState(defaultMapYears);

  const optionDisabled = () => {
    return selectedOption.length >= 12;
  };

  const isRequired = () => {
    return selectedOption.length < 2;
  };

  const onChanceHandler = (value, actionMeta) => {
    if (actionMeta.removedValue && selectedOption.length < 3) {
      return;
    }
    const sortedValue = value.sort((a, b) => a.value - b.value);
    setSelectedOption(sortedValue);
    mapYearCallback(sortedValue);
  };

  useEffect(() => {
    setSelectedOption(selectedOption);
  }, []);

  const colourStyles = {
    control: (styles) => ({...styles, backgroundColor: 'white'}),
    option: (styles, {data, isDisabled, isFocused, isSelected}) => {
      return {
        ...styles,
        // backgroundColor: isDisabled ? 'black' : 'white',
        color: (!isDisabled) ? 'black' : 'lightgray',
        cursor: isDisabled ? 'not-allowed' : 'default',
      };
    },
  };

  return (
    <label htmlFor="mapYears">
      <div className="map-year-select_label">{config.filters.mapYears.title}</div>
      <Tippy content={config.filters.mapYears.description} interactive>
        <span className="icon">
          <Icon.Info className="feather"/>
        </span>
      </Tippy>

      <Select
        ref={mapYearOptions}
        defaultValue={selectedOption}
        value={selectedOption}
        isMulti
        name="colors"
        options={mapYears}
        required={isRequired}
        onChange={onChanceHandler}
        className="years-select-container"
        classNamePrefix="years-select"
        closeMenuOnSelect={false}
        isSearchable={false}
        isOptionDisabled={optionDisabled}
        isClearable={false}
        minMenuHeight={200}
        styles={colourStyles}
      />
    </label>
  );
};

export default MapYearSelect;
